import React, { useState, useEffect, useContext } from 'react'

import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Button } from 'semantic-ui-react'

import { IProject, ITheme } from '../../../api/Data'
import Data from '../../../api/Data'
import { GlobalContext } from '../../../contexts/GlobalContext'

import SubSection from '../../../components/common/SubSection'
import Title from '../../../components/common/Title'

import CollaborateTabSharingPage from './CollaborateTabSharingPage'
import CollaborateTabContestPage from './CollaborateTabContestPage'

const CollaborateTab = (props: IProps) => {
  const { hasUserMadeChange, dispatchGlobalContext } = useContext(GlobalContext)

  // Props
  const { location, match, history, projectTitle, project, setProject, theme, setTheme, exitProject } = props

  // States
  const [activeTab, setActiveTab] = useState<string>('Sharing')
  const [validationError, setValidationError] = useState<string | null>(null)

  // Url search query navigation
  useEffect(() => {
    if (location.search.startsWith('?tab=sharing')) setActiveTab('Sharing')
    else if (location.search.startsWith('?tab=contest')) setActiveTab('Contest')
    else history.push(`/projects/${match.params.projectSlug}/collaborate?tab=sharing`)
  }, [history, location.search, match.params.projectSlug])

  // ------------------------------------------------Project handles------------------------------------------------
  const handleProjectChange = (e: any, data: any) => {
    const { name, value, checked } = data

    // Record any change made on the form
    if (!hasUserMadeChange) dispatchGlobalContext({ type: 'set user has made changes', payload: true })

    // Reset errors
    if (validationError === name) setValidationError(null)
    
    let newValue
    
    if (name === 'enableContest')
      newValue = checked
    else
      newValue = value
    
    setProject({ ...project, [name]: newValue })
  }

  const handleSubmitProject = async () => {
    dispatchGlobalContext({ type: 'set loading', payload: true })

    const { data, error } = await Data.updateProject(project)

    if (error) {
      dispatchGlobalContext({ type: 'set loading', payload: false })
      alert('Oops, something went wrong')
    }

    setTimeout(() => {
      setProject(data)
      dispatchGlobalContext({ type: 'set loading', payload: false })
    }, 1000)
  }

  // ------------------------------------------------Theme handles------------------------------------------------
  const handleSubmitTheme = async () => {
    dispatchGlobalContext({ type: 'set loading', payload: true })

    const { data, error } = await Data.updateTheme(theme)

    dispatchGlobalContext({ type: 'set user has made changes', payload: false })

    if (error) {
      dispatchGlobalContext({ type: 'set loading', payload: false })

      dispatchGlobalContext({ type: 'set user has made changes', payload: false })

      return alert(`An error occurred while updating your theme => ${error.response?.data}`)
    }

    setTheme(data)

    setTimeout(() => dispatchGlobalContext({ type: 'set loading', payload: false }), 1000)
  }
  const hasFormError = () => {
    const { enableContest, contestDescription } = project

    if (enableContest) {
      if (!contestDescription) {
        setValidationError('contestDescription')
        history.push(`/projects/${match.params.projectSlug}/collaborate?tab=contest`)
        return true
      }
    }
  }
  
  const handleSave = () => {
    if (hasFormError()) return

    handleSubmitProject()
    handleSubmitTheme()
  }

  const uploadMyFirstVideo = () => {
    history.push(`/projects/${project.slug}/curate`, { uploadModal: true })
  }

  return (
    <>
      <Title title={projectTitle}>
        <>
          {activeTab === 'Sharing' && (
            <Button compact color="orange" onClick={uploadMyFirstVideo}>
              Upload Your First Video
            </Button>
          )}
          {activeTab === 'Contest' && (
            <Button compact secondary disabled={!hasUserMadeChange} onClick={handleSave} style={{ border: '1px solid #fff' }}>
              Save
            </Button>
          )}
          <Button compact onClick={exitProject}>
            Close
          </Button>
        </>
      </Title>

      <SubSection hasGreyBackground>
        <>
          {activeTab === 'Sharing' && (
            <CollaborateTabSharingPage
              project={project}
            />
          )}

          {activeTab === 'Contest' && (
            <CollaborateTabContestPage
              project={project}
              validationError={validationError}
              handleChange={handleProjectChange}
            />
          )}
        </>
      </SubSection>
    </>
  )
}

interface IProps extends RouteComponentProps<any> {
  projectTitle: string
  project: IProject
  theme: ITheme
  setProject: (arg: IProject) => void
  setTheme: (arg: ITheme) => void
  exitProject: () => void
}

export default withRouter(CollaborateTab)
